import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getDyanmicUiFn = (reqBody) => {
    try {
        const response = axiosInstance.get(API_URLS.page_ui, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};



export const deleteDyanmicUiFn = (reqBody) => {
    try {
        const response = axiosInstance.delete(API_URLS.page_ui, {
            data: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const patchDyanmicUiFn = (reqBody, url) => {
    try {
        const response = axiosInstance.patch(API_URLS.page_ui, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const postDyanmicUiFn = (reqBody, url) => {
    try {
        const response = axiosInstance.post(API_URLS.page_ui, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

